module.exports = __webpack_public_path__ + "img/slash.73b6a61d.svg";